module.exports = __webpack_public_path__ + "static/media/bills_downloadReceipt_green.1e0d7ed9.svg";